import { render, staticRenderFns } from "./blogDetail.vue?vue&type=template&id=34d12e4c&scoped=true"
import script from "./blogDetail.vue?vue&type=script&lang=js"
export * from "./blogDetail.vue?vue&type=script&lang=js"
import style0 from "./blogDetail.vue?vue&type=style&index=0&id=34d12e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d12e4c",
  null
  
)

export default component.exports